import _BaseAPIService from '../_BaseAPIService';

const apiService = _BaseAPIService.instance;

const slug = 'api';
const PurchasesServices = {
  // Define your API functions here
  getList: async () => {
    const response = await apiService.get('/Purchase/GetList');
    return response.data;
  },
  create: async (postData) => {
    const response = await apiService.post(`/${slug}/purchase`, postData);
    return response.data;
  },
  
  view: async (id) => {
    const response = await apiService.get(`${slug}/Purchase/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete('/Purchase/Delete?id=' +id);
    return response.data;
  },
  update: async (id, updatedData) => {
    const response = await apiService.put(`/${slug}/purchase/${id}`, updatedData);
    return response.data;
  },
};

export default PurchasesServices;
